import React, { useState, useEffect } from "react";
import { Row, Col } from 'react-bootstrap'
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import {Helmet} from "react-helmet";
import { useParams } from 'react-router-dom';

const OverviewEvaluate = props => {

    const { roomId } = useParams();
    const [finishPercent, setFinishPercent] = useState(0);
    const [evaluateAll, setEvaluateAll] = useState([]);

    useEffect(() => {
        const userId = AuthService.getCurrentUser().id
        try {
            UserService.getFriendShipList(userId, {roomId}).then((response) => {
                if (response.data.status.code === 'SUCCESS' && response.data.data && response.data && response.data.data[0] && response.data.data[0].targets) {
                    let countPercent = 0
                    let evaluateData = [];  
                    const targets = response.data.data[0].targets

                    let countTarget = response.data.data[0].targets.length;
                    for (const [index, value] of response.data.data[0].targets.entries()) {

                        if (value.answerAt !== null) {
                            countPercent++
                        }
                        
                        let divide3 = countTarget/3;
                        let divide2 = countTarget/2;

                        if(countTarget%3 ===0){
                            divide3 = divide3-1;
                        }

                        if(countTarget%2 ===0){
                            divide2 = divide2-1;
                        }
                      
                        if(targets[index].user.roles[0] === 'TEACHER'){
                            evaluateData.splice(1, 0, {
                                'text': targets[index].answers !== null ? '<img class="check-evaluate" src="/images/evaluate/check.png"><span class="already-evaluate">ประเมินแล้ว</span>' : '<span class="no-evaluate">ยังไม่ประเมิน</span>',
                                'text_role':  targets[index].user.roles[0],
                                'id': targets[index].user.id,
                                'name': "ครู"+targets[index].user.fullName,
                                'image': '/images/evaluate/School_icon2.png',
                                'class': ''
    
                            });

                        } else if(userId === targets[index].user.id) {
                            evaluateData.splice(0, 0, {
                                'text': targets[index].answers !== null ? '<img class="check-evaluate" src="/images/evaluate/check.png"><span class="already-evaluate">ประเมินแล้ว</span>' : '<span class="no-evaluate">ยังไม่ประเมิน</span>',
                                'text_role':  targets[index].user.roles[0],
                                'id': targets[index].user.id,
                                'name': 'ตัวเอง',
                                'image': '/images/evaluate/School_icon1.png',
                                'class': ''
    
                            });
                        }                  
                        else{
                            let classText = '';
                            if(index >=  divide3*3){
                                classText = 'last-3';
                            }

                            if(index >=  divide2*2){
                                classText = classText+' last-2';
                            }

                            evaluateData.push({
                                'text': targets[index].answers !== null ? '<img class="check-evaluate" src="/images/evaluate/check.png"><span class="already-evaluate">ประเมินแล้ว</span>' : '<span class="no-evaluate">ยังไม่ประเมิน</span>',
                                'text_role':  targets[index].user.roles[0],
                                'id': targets[index].user.id,
                                'name': targets[index].user.fullName,
                                'image': '/images/evaluate/School_icon3.png',
                                'class': classText   
                            })
                        }
                        

                    }
                    setFinishPercent((countPercent* (100/countTarget)).toFixed(2))                  
                    setEvaluateAll(evaluateData);
                                 
                }
            });
        } catch (error) {

        }
    }, [])

    const evaluation = (userId) => {
        if (userId) {
            window.location.href = `/evaluate/person/${roomId}/${userId}`
        }
    }

    return (
        <div className="">    
            <Helmet>
                <title>เราเห็นอุปนิสัยเชิงบวกอะไรบ้าง ที่เกิดขึ้นกับตัวเอง คุณครูและเพื่อน - Mindsetmaker.co</title>
                <meta property="og:title"       content={`เราเห็นอุปนิสัยเชิงบวกอะไรบ้าง ที่เกิดขึ้นกับตัวเอง คุณครูและเพื่อน - Mindsetmaker.co`} />
                <meta property="og:description" content={`เริ่มกิจกรรมค้นหาสิ่งดีๆ ในช่วงเวลาที่ผ่านมา เพื่อค้นพบอุปนิสัยเชิงบวกในตัวเรา เพื่อนๆและคุณครู`} />
            </Helmet>              
            <Row>
                <Col xs={12} md={12}  className="w-100 text-center pt-4 ">
                    <h2 class="font-sarabun-bold primary-text " >เราเห็นอุปนิสัยเชิงบวกอะไรกันบ้างนะ?</h2>
                </Col>   
            </Row>
            <Row style={{"paddingBottom": "54px"}}>                
                <Col className="main-evaluate-overview pb-3">                        
                    <Row>                                           
                        <Col xs={12} md={6} className="w-100 px-4 pt-3">
                            <h4 class="font-sarabun-bold pt-md-5">ในช่วงที่ผ่านมาเราได้มองเห็นอุปนิสัยเชิงบวกอะไร<span className="doNotWrap">ในตัวเอง เพื่อนๆ </span> และคุณครูของเรากันบ้างนะ? ไปร่วมกันค้นหาอุปนิสัยเชิงบวกของ<span className="doNotWrap">ทุกคนกันเลยค่ะ</span></h4>
                        </Col>
                        <Col  xs={12} md={6} className="w-100 text-center">
                            <img src='/images/evaluate/banner_overview.png' className="mb-1 d-inline pr-2 w-100" />                        
                        </Col>    
                    </Row>
                </Col>                   
            </Row>        
            <Row className="bg-light-blue">     
                <Col className="main-evaluate-overview">
                    <Row className="mx-2 padding-overview-percent-div">
                        <Col xs={12} md={12} className="px-3 px-md-4 py-2 bg-white border-radius-12 border-blue evaluate-box">
                            <div class="text-center">
                                <h6 className="font-sarabun-bold">
                                    เรามาช่วยกันตามหาอุปนิสัยเชิงบวกให้ครบกันเถอะ!
                                </h6>
                            </div>
                            <div class="w3-default-bg w3-round w-100">
                                <div className={`w3-container w3-round ${finishPercent > 0 ? 'w3-bluesky' : ''}`} style={{"width": finishPercent + "%", "height":"15px"}}></div>
                            </div>
                            <div class="text-center">
                                <h3 className="font-primary-color font-sarabun-bold">{ finishPercent }%</h3>
                            </div>                    
                        </Col>
                    </Row>
                </Col>    
            </Row>
            <Row className="bg-light-blue">
                <Col className="main-evaluate-overview" style={{"top": "-25px"}}> 
                    <Row className="mx-3 mb-5">
                    {evaluateAll.map((evaluateA, i) => (
                           
                            <Col key={i} xs={6} md={4} className={`${evaluateA.class} px-3 w-100 text-center evaluate-border-level click-pointer py-2`} onClick={() => evaluation(evaluateA.id)}>
                                <img src={evaluateA.image} className="eimg w-100" /> 
                                <h4 className="font-sarabun-bold mb-0"> {evaluateA.name} </h4>
                                <h6><div dangerouslySetInnerHTML={{ __html: evaluateA.text }} /></h6>    
                            </Col>
                          
                        ))}
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default OverviewEvaluate;